import {Metric as ServerMetricType} from 'app_api/projects/metrics/types';

/**
 * Enum helper that should match Metric.type from:
 * webapp/app_api/projects/metrics/types.d.ts
 */
export enum MetricType {
  Behavior = `behavior`,
  Formula = `formula`,
  Metric = `metric`,
}

// Enforce that it matches server generated type.
// eslint-disable-next-line no-unused-expressions
MetricType satisfies Record<string, ServerMetricType['type']>;

export enum TopLevelMetricTypeFilter {
  All = `all`,
  Metric = `metric`,
  Formula = `formula`,
}
